import { to, SpringValue } from '@react-spring/web'

//base code provided by Nivo: https://github.com/plouc/nivo/blob/master/packages/treemap/src/transitions.ts

export const htmlNodeTransform = (x: SpringValue<number>, y: SpringValue<number>) => to([x, y], (x, y) => `translate(${x}px, ${y}px)`)

export const htmlParentLabelTransform = (x: SpringValue<number>, y: SpringValue<number>, rotation: SpringValue<number>) =>
    to(
        [x, y, rotation],
        (x, y, rotation) => `translate(${x - (rotation === 0 ? 0 : 5)}px,${y - (rotation === 0 ? 5 : 0)}px) rotate(${rotation}deg)`
    )
